
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ComEmpty extends Vue {
  @Prop({ default: '当前暂无结果' }) content!: string;

  @Prop({ default: '' }) wrapClass!: string;
}

